<ng-template #sortableTemplate>
    <button (click)="handleSort(sortProp || prop)" [ngClass]="{ 'is-sorted': isSorted }">
    <span [translationEditableDirective]="name">{{ name | translate}}</span>
    
    <i *ngIf="!isSorted" class="fas fa-sort"></i>
    <i *ngIf="isSorted && sort === 'asc'" class="fas fa-sort-up"></i>
    <i *ngIf="isSorted && sort === 'desc'" class="fas fa-sort-down"></i>
  </button>
</ng-template>

<ng-template #nonSortableTemplate>
  <span [translationEditableDirective]="name">{{ name | translate}}</span>
</ng-template>

<ng-container *ngTemplateOutlet="sortable ? sortableTemplate : nonSortableTemplate"></ng-container>